export const environment = {
  //Sell360 will be main branch for sell360 distribution
  production: true, 
  apiDomain: 'https://spencer-latest.sell360.app',
  apiUrl: 'https://spencer-latest.sell360.app/distributor-api',
  // apiDomain: 'https://demo.sell360.app',
  // apiUrl: 'https://demo.sell360.app/distributor-api',
  
  // apiDomain: 'https://shahi-latest.sell360.app', 
  // apiUrl: 'https://shahi-latest.sell360.app/distributor-api',   
  

  // apiDomain: 'https://asg.sell360.app', 
  // apiUrl: 'https://asg.sell360.app/distributor-api', 

  //  apiDomain: 'https://shahi-revamp.sell360.app',  
  // apiUrl: 'https://shahi-revamp.sell360.app/distributor-api',   

  // apiDomain: ' https://mtek.sell360.app',
  // apiUrl: ' https://mtek.sell360.app/distributor-api',


  
  DISCOUNT_TYPES: {
    NORMAL: 1, // noramal means flat value * qty
    PERCENTAGE: 2, // Percentage means (value/100) * qty
  },
  ORDER_TYPE: {
    Regular_Order: '0',
    Credit_Order_Without_Discount: '1',
    Credit_Order_With_Discount: '2',
  },

  CREDIT_ORDER_TYPE: {
    Regular_Order: 0,
    Credit_Order_Without_Discount: 1,
    Credit_Order_With_Discount: 2,
  },
  SLAB_TYPE: {
    ALL: 0,
    NORMAL: 1,
    EXCLUSIVE: 2,
    SKU_BASE: 3,
    BRAND_BASE: 4,
    CATEGORY_BASE: 5,
  },

  SLAB_RULE: {
    RULE_1: 1, //Noraml
    RULE_2: 2, // matching slab ranges with quantity
  },
  SCHEME_RULE: {
    RULE_5: 5, // Fixed Quantity of the Complimentary Product
    RULE_6: 6, // Equal Quantity of Complimentary Product w.r.t Primary product
  },
};
